import { AuthenticatedUserDto } from '~/services/Http';

export const authenticatedUserIsAdmin = (
  userDetails?: AuthenticatedUserDto,
) => {
  if (!userDetails) {
    return false;
  }

  // TODO: I think this check is for Solaforce Application Admin, not regular HR Admins. Maybe rename hook? - Juhana
  return (
    (userDetails.username === 'solaforce' ||
      userDetails.roles.includes('ADMIN')) &&
    !userDetails.employeeId
  );
};
